import React from "react";
import "./App.css";
import { ControllerRouter } from "./Views";

export function App(props: {
  route: { controllerName: string; actionName: string };
  props: any;
}) {
  return (
    <ControllerRouter
      controllerName={props.route.controllerName}
      actionName={props.route.actionName}
      pageProps={props.props}
    />
  );
}
